import { camelCase } from 'change-case';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';

export const translateApiError = (
  resource: string,
  field: string,
  errorCode: string,
) => {
  if (!resource || !field || !errorCode) {
    return null;
  }

  const camelField = camelCase(field);
  const camelErrorCode = camelCase(errorCode);
  const value =
    constants.TRANSLATE_API_ERROR_VALUE[resource][camelField][camelErrorCode];

  return i18n.t(`ui.error.api.${camelErrorCode}`, value);
};
